export { default, StyledCarousel, responsive } from './category-tiles-carousel';
